import React from "react";
import { LogIn } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-parchment" data-testid="admin-login">
      <div className="max-w-md w-full mx-auto bg-white border border-rule p-10">
        <img src="/logo.png" alt="Tomorrow's Doctors" className="h-14 mx-auto mb-8" />
        <div className="flex items-center gap-3 mb-5 justify-center">
          <span className="h-px w-8 bg-medblue" />
          <span className="text-[10px] uppercase tracking-[0.28em] text-medblue">Admin Portal</span>
          <span className="h-px w-8 bg-medblue" />
        </div>
        <h1 className="font-serif text-3xl text-navy text-center leading-tight">
          Sign in to Tomorrow&rsquo;s Doctors.
        </h1>
        <p className="mt-5 text-sm text-navy/65 text-center leading-relaxed">
          Access is restricted to editors. Sign in with your Google account to manage interviews and subscribers.
        </p>
        <button onClick={handleLogin} className="mt-8 btn-primary w-full justify-center" data-testid="google-login-btn">
          <LogIn size={14} className="mr-2" /> Continue with Google
        </button>
        <p className="mt-6 text-[10px] uppercase tracking-[0.24em] text-navy/40 text-center">
          You&rsquo;ll be returned to /admin after authentication.
        </p>
      </div>
    </div>
  );
}
